import {
  SearchCategoryItem,
  AccountNavItem,
  AccountMenuItem,
  ServiceNavItem,
  ServiceNavBasicItem
} from '@raksul/kamii-vue'

export const searchCategoryItem: SearchCategoryItem[] = [
  {
    label: 'すべて',
    value: 'すべて',
    url: 'https://raksul.com/search?keyword=',
    target: '_blank',
    includeCategoryQuery: false
  },
  {
    label: '紙・シール',
    value: '紙・すべて',
    url: 'https://raksul.com/search?keyword=',
    target: '_blank',
    includeCategoryQuery: true
  },
  {
    label: '集客支援',
    value: '集客支援・すべて',
    url: 'https://raksul.com/search?keyword=',
    target: '_blank',
    includeCategoryQuery: true
  },
  {
    label: 'グッズ・ノベルティ',
    value: 'グッズ・ノベルティ',
    url: 'https://novelty.raksul.com/search?keyword=',
    target: '_blank',
    includeCategoryQuery: false
  },
  {
    label: '梱包材・ダンボール',
    value: '梱包材・ダンボール',
    url: 'https://search.notosiki.co.jp/?query=',
    target: '_blank',
    includeCategoryQuery: false
  },
  {
    label: '店舗用品・包装資材',
    value: '店舗用品・包装資材',
    url: 'https://stockroom.raksul.com/search?keyword=',
    target: '_blank',
    includeCategoryQuery: false
  },
  {
    label: 'オンラインデザイン',
    value: 'オンラインデザイン',
    url: 'https://raksul.com/search?keyword=',
    target: '_blank',
    includeCategoryQuery: true
  },
  {
    label: 'ご利用ガイド',
    value: '4407920522127', // category id of Apparel on guide page
    url: 'https://guide.raksul.com/hc/ja/search?query=',
    target: '_blank',
    includeCategoryQuery: true
  }
]

export const accountNavItems: AccountNavItem[] = [
  {
    icon: 'call',
    label: 'お問い合わせ',
    url: '/contact'
  },
  {
    icon: 'list',
    label: '注文一覧',
    url: '/orders'
  }
]

export const accountMenuItems = (coreBaseUrl: string ): AccountMenuItem[] => {
  return [
    {
      label: 'メールアドレスの変更',
      url: `${coreBaseUrl}/account/settings/email`
    },
    {
      label: 'パスワードを変更',
      url: `${coreBaseUrl}/account/settings/password`
    },
    {
      label: 'メールマガジンの配信設定',
      url: `${coreBaseUrl}/account/settings/mail_magazine`
    },
    {
      label: 'クレジットカードの追加・削除',
      url: `${coreBaseUrl}/mypage/account/card`
    },
    {
      label: '出荷元の追加・削除',
      url: `${coreBaseUrl}/mypage/account/sender`
    },
    {
      label: 'お届け先の追加・削除',
      url: `${coreBaseUrl}/mypage/account/recipient`
    }
  ]
}

export const serviceNavItems: ServiceNavItem[] = [
  {
    label: 'TOP',
    url: '/'
  },
  {
    label: '当日・翌日出荷',
    url: '/column/fast_shipping_selections'
  },
  {
    label: 'デザインシミュレータ',
    url: '/design_simulator'
  },
  {
    label: 'サイズ集計',
    url: '/group_buy_items'
  },
  {
    label: '注文履歴・再注文',
    url: '/orders'
  },
  {
    label: 'カタログ無料請求',
    url: '/catalog'
  }
]

export const desktopServiceNavBasicItems: ServiceNavBasicItem[] = [
  {
    icon: 'calculator',
    label: '見積もりリスト',
    url: '/estimate'
  },
  {
    icon: 'questionCircle',
    label: 'ご利用ガイド',
    url: 'https://guide.raksul.com/hc/ja/categories/4407920522127'
  }
]

export const mobileServiceNavBasicItems: ServiceNavBasicItem[] = [
  {
    icon: 'calculator',
    label: '見積もりリスト',
    url: '/estimate'
  },
  {
    icon: 'call',
    label: 'お問い合わせ',
    url: '/contact'
  },
  {
    icon: 'questionCircle',
    label: 'ご利用ガイド',
    url: 'https://guide.raksul.com/hc/ja/categories/4407920522127'
  }
]
